import { ExpressCheckoutElement } from '@stripe/react-stripe-js';

export default function ThirdPartyPaymentButton({
    setPaymentRequest,
    confirmPayment,
    plan,
}) {
    console.log("ThirdPartyPaymentButton", plan);

    return (
        <div className="mb-2">
            <ExpressCheckoutElement
                options={{
                    emailRequired: true,
                    layout: {
                        maxRows: 0,
                        maxColumns: 0,
                        overflow: 'never',
                    }
                }}
                onReady={() => {
                    console.log("ExpressCheckoutElement onReady");
                    setPaymentRequest(true);
                }}
                onLoadError={(error) => {
                    console.log("ExpressCheckoutElement onLoadError", error);
                }}
                onConfirm={async (confirmedObject) => {
                    const email = confirmedObject.billingDetails.email;
                    await confirmPayment(email);
                }} />
        </div>
    );
}
